export default "__VITE_ASSET__CtZSv1K5__"